<template>
  <div>
    <BaseFilter title="LOCATION" :state="locations">
      <template #default="{ data }">
        <div v-for="item in data" :key="item.id">
          <b-form-checkbox
            v-model="location"
            name="location-filter"
            :value="item.id"
            stacked
            :disabled="item.disabled"
          >
            {{ item.name }}
          </b-form-checkbox>
          <b-form-checkbox-group
            v-model="region"
            name="meleca-filter"
            :options="item.regions"
            value-field="id"
            text-field="name"
            class="ml-3"
            stacked
            disabled-field="disabled"
          />
        </div>
      </template>
    </BaseFilter>
  </div>
</template>

<script>
import localAsyncAction from '@/mixins/localAsyncAction'
import apiModules from '@/services'
import BaseFilter from '@/components/BaseFilter/BaseFilter'
import { UK_COUNTRY_ID } from '@/constants'

export default {
  name: 'LocationFilter',
  components: {
    BaseFilter
  },
  mixins: [
    localAsyncAction({
      key: 'locations',
      initialState: [],
      fetcher: {
        methodName: 'fetchLocations',
        handler: apiModules.fetchLocations
      }
    })
  ],
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      location: this.value.location,
      region: this.value.region,
      filters: this.value
    }
  },
  watch: {
    location(value) {
      this.$emit('input', { ...this.value, location: value })
    },
    region(value) {
      this.$emit('input', { ...this.value, region: value })
      if (value.length > 0 && this.location.indexOf(UK_COUNTRY_ID) === -1)
        this.location.push(UK_COUNTRY_ID)
    },
    filters: {
      handler(filters) {
        this.fetchLocations(filters)
      },
      deep: true
    },
    value(value) {
      this.location = value.location
      this.region = value.region
      this.filters = {
        ...this.value,
        location: value.location,
        region: value.region
      }
    }
  },
  created() {
    this.fetchLocations(this.filters)
  }
}
</script>
